import * as csv from '@fast-csv/parse';
import os from 'os-browserify/browser';
import { lowerTrimString } from '../normalize';

export default async function parseCsv(csvData) {
  const parseredCsv = csvData.split('\r\n');
  if (parseredCsv && (parseredCsv.length === 0 || parseredCsv[0] === '')) {
    throw new Error('csv vazio');
  }
  return new Promise((resolve) => {
    const results = [];
    const stream = csv.parse({
      headers: header => header.map(column => lowerTrimString(column)),
      trim: true,
      strictColumnHandling: true,
      delimiter: ';',
      ignoreEmpty: true,
    })
      .on('error', error => console.error('csv.parse error:', error))
      .on('data', row => results.push(row))
      .on('end', rowCount => console.log(`Parsed ${rowCount} rows`));

    stream.write(parseredCsv.join(os.EOL));
    stream.end(() => resolve(results));
  });
}
